import bService from '@/api/base-api'
import { CONTRACT_MANAGER_URL } from '@/configs/service-url'

const list = async (hotelId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/transfer`
  const result = await bService.get(url)

  return result
}

const create = async (hotelId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/transfer`
  const result = await bService.post(url, data)

  return result
}

const update = async (hotelId, trasnferId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/transfer/${trasnferId}`
  const result = await bService.put(url, data)

  return result
}

const updateIsDefault = async (hotelId, transferId, isDefault) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/transfer/${transferId}/is-default`
  const data = {
    isDefault: isDefault
  }
  const result = await bService.put(url, data)

  return result
}

const remove = async (hotelId, transferId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/transfer/${transferId}`
  const result = await bService.remove(url)

  return result
}

export default {
  list,
  create,
  update,
  updateIsDefault,
  remove
}
